
const store = {
  // An object that will contain all dom nodes with .js class names
  // Populated by DomWrangler -> /js/framework/components/domWrangler.js
  dom: {}
}

export default store
